import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { useAccount, useDisconnect } from 'wagmi';
import { toast } from 'react-toastify';
import useWalletConnect from '../hooks/useWalletConnect';
import { useWeb3Modal } from '@web3modal/wagmi/react';
import { defaultProvider } from '../helpers/web3utils';
import { ethers } from 'ethers';
const Header = ({ setT, t }) => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [balance, setBalance] = useState(0);
  const [showInfo, setShowInfo] = useState();
  const { open, close } = useWeb3Modal();
  const { connectWallet } = useWalletConnect();
  const { address, isConnected } = useAccount();
  const { disconnect } = useDisconnect();
  const handleDisconnect = () => {
    disconnect();
    toast.success('Disconnect successfully!');
  };
  useEffect(() => {
    if (isConnected) {
      getBNBBalance();
    } else {
      setBalance(0);
    }
  }, [isConnected, t]);

  const getBNBBalance = async () => {
    const tmpBalance = await defaultProvider().getBalance(address);
    setBalance(ethers.formatEther(tmpBalance));
 
  };
  return (
    <header className="header">
      <div className="header-wrap">
        <div className={` ${showSidebar ? 'is-active' : ''} header-box`}>
          <ul className="header-menu">
            {/* <li className="header-menu__item">
              <a href="https://docs.stabilityworld.ai/stability-world-ai/about-us/about-stability-world-ai" className="header-menu__anchor" target="_blank" rel="noreferrer">
                About
              </a>
            </li>
            <li className="header-menu__item">
              <a href="" className="header-menu__anchor">
                DEX
              </a>
            </li>
            <li className="header-menu__item">
              <a href="" className="header-menu__anchor">
                Points
              </a>
            </li> */}
            <li className="header-menu__item">
              <a
                href="https://stabilityworld.ai/"
                className="header-menu__anchor"
                target="_blank"
                rel="noreferrer"
              >
                Website
              </a>
            </li>
            <li className="header-menu__item">
              <a
                href="https://discord.com/invite/KU9KEM8nG2"
                className="header-menu__anchor"
                target="_blank"
                rel="noreferrer"
              >
                Discord
              </a>
            </li>
            <li className="header-menu__item">
              <a
                href="https://t.me/StabilityworldAI"
                className="header-menu__anchor"
                target="_blank"
                rel="noreferrer"
              >
                Telegram
              </a>
            </li>
            <li className="header-menu__item">
              <a
                href="https://twitter.com/StabilityW_AI"
                className="header-menu__anchor"
                target="_blank"
                rel="noreferrer"
              >
                Twitter
              </a>
            </li>
          </ul>
          <div className="header-btn">
            <a href="#" className="header-btn__item --app">
              <span className="icon">
                <img src="./assets/images/logo_bnb.png" alt="" />
              </span>
              BNB
            </a>
            {/* <a href="#" className="header-btn__item --app">
            <span className="icon">
              <img src="./assets/images/logo_solana.png" alt="" />
            </span>
            Solana
          </a> */}
            {!isConnected ? (
              <div className="header-btn__item --wallet" onClick={() => connectWallet()}>
                <span className="icon">
                  <img src="./assets/images/icon_wallet.png" alt="" />
                </span>
                Connet Wallet
              </div>
            ) : (
              <div className="header-acc">
                <p className="header-acc__top js-show-acc " onClick={() => setShowInfo(!showInfo)}>
                  <span className="icon">
                    <img src="./assets/images/avata.png" alt="" />
                  </span>
                  <span className="txt">
                    {' '}
                    {address ? address.substring(0, 6) + '...' + address.slice(-4) : '...'}
                  </span>
                </p>
                {showInfo ? (
                  <div
                    className={`acc-body is-active`}
                    style={{ backgroundColor: 'rgba(0,0,0,1)' }}
                  >
                    <div className="acc-body__wrap">
                      <p className="acc-body__logo">
                        <img src="./assets/images/avata.png" alt="" />
                      </p>
                      <p className="acc-body__name">
                        {' '}
                        {address ? address.substring(0, 6) + '...' + address.slice(-4) : '...'}
                      </p>
                      <p className="acc-body__info">
                        <span className="number">{Number(balance).toFixed(8)} BNB</span>
                      </p>
                    </div>
                    <ul className="acc-body__menu">
                      <li style={{ cursor: 'pointer' }} onClick={() => handleDisconnect()}>
                        <a>Disconnect</a>
                      </li>
                    </ul>
                  </div>
                ) : null}
              </div>
            )}
          </div>
        </div>

        <div
          className={`hamburger-box js-show-menu ${showSidebar ? 'is-active' : ''}`}
          onClick={() => setShowSidebar(!showSidebar)}
        >
          <div className="hamburger-inner" />
        </div>
      </div>
    </header>
  );
};

export default Header;
